__turbopack_context__.v({
  "loader-strip": "MUA9UW_loader-strip",
  "loader-strip-container": "MUA9UW_loader-strip-container",
});
